export default __webpack_public_path__ + "static/media/avatar_xiao_mei3.72e012c8.mp3";